import './utils/jquery';
import './polyfills/nodeListForEach';
import './polyfills/elementClosest';
import $script from 'scriptjs';
import { SiteAgeGate, PageAgeGate } from '@pixelunion/age-gate';

import { initLoadInAnimationsAutoplay } from '@pixelunion/load-in-animations';
import PxsMap from '@pixelunion/pxs-map';
import VideoSection from '@pixelunion/pxs-video';
import rimg from '@pixelunion/rimg-shopify';
import ShopifySectionsManager from '@pixelunion/shopify-sections-manager';
import flickityTouchFix from './helpers/FlickityTouchFix';

// Sections
import Collection from './sections/Collection';
import DynamicBlog from './sections/DynamicBlog';
import DynamicCountdown from './sections/DynamicCountdown';
import DynamicLogoList from './sections/DynamicLogoList';
import DynamicPromotions from './sections/DynamicPromotions';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTestimonials from './sections/DynamicTestimonials';
import Product from './sections/Product';
import StaticAddresses from './sections/StaticAddresses';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticFooter from './sections/StaticFooter';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from './sections/StaticHeader';
import StaticPassword from './sections/StaticPassword';
import StaticPage from './sections/StaticPage';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import Search from './sections/Search';

// Components
import Share from './components/Share';

const scripts = document.querySelector('[data-scripts]');

$script([scripts.dataset.shopifyApiUrl], () => {
  initLoadInAnimationsAutoplay({ threshold: 0.1 });
  rimg.init();
  const sections = new ShopifySectionsManager();

  sections.register('dynamic-featured-collection', section => new Collection(section));
  sections.register('dynamic-featured-product', section => new Product(section));
  sections.register('dynamic-blog', section => new DynamicBlog(section));
  sections.register('dynamic-countdown', section => new DynamicCountdown(section));
  sections.register('dynamic-logo-list', section => new DynamicLogoList(section));
  sections.register('dynamic-promotions', section => new DynamicPromotions(section));
  sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
  sections.register('dynamic-testimonials', section => new DynamicTestimonials(section));
  sections.register('pxs-map', section => new PxsMap(section));
  sections.register('pxs-video', section => new VideoSection(section));
  sections.register('static-addresses', section => new StaticAddresses(section));
  sections.register('static-article', section => new Share(section));
  sections.register('static-blog', section => new StaticBlog(section));
  sections.register('static-cart', section => new StaticCart(section));
  sections.register('static-collection', section => new Collection(section));
  sections.register('static-contact-page', section => new StaticPage(section));
  sections.register('static-footer', section => new StaticFooter(section));
  sections.register('static-gift-card', section => new StaticGiftCard(section));
  sections.register('static-header', section => new StaticHeader(section));
  sections.register('static-page', section => new StaticPage(section));
  sections.register('static-password', section => new StaticPassword(section));
  sections.register('static-product', section => new Product(section));
  sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
  sections.register('static-quickshop', section => new Product(section));
  sections.register('search', section => new Search(section));
  sections.register('age-gate', section => new PageAgeGate(section));

  flickityTouchFix();
});

const ageGatePage = document.getElementById('age-gate-page');

if (ageGatePage) {
  new SiteAgeGate(ageGatePage);
}
